import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { nameValidator } from 'src/app/components/forms/validators/name-validator';
import { emailValidator } from 'src/app/components/forms/validators/email-validator';

@Component({
  selector: 'app-crissis-assistance-form-help',
  templateUrl: './crissis-assistance-form-help.component.html',
  styleUrls: ['./crissis-assistance-form-help.component.css'],
})
export class CrissisAssistanceFormHelpComponent implements OnInit {
  formCrissisHelp!: FormGroup;
  name = new FormControl('', [Validators.required, nameValidator]);
  email = new FormControl('', [Validators.required, emailValidator]);
  message = new FormControl('');

  constructor(private router: Router, public fb: FormBuilder) {}

  ngOnInit(): void {
    this.formCrissisHelp = this.fb.group({
      name: this.name,
      email: this.email,
      message: this.message,
      read: [false, Validators.requiredTrue],
    });
  }
  onSubmit() {
    console.log(this.formCrissisHelp.value);
  }
}
